import type { UpdateMeRequest } from '@lunya/contracts'

import type { Gender } from '../../types'

export type UpdateUserInput = {
  firstName?: string
  gender?: Gender
}

/** Клиентский ввод (A1 · имя/пол) → тело `PATCH /users/me`. */
export function mapUserToApi(input: UpdateUserInput): UpdateMeRequest {
  return {
    first_name: input.firstName,
    gender: input.gender,
  }
}
